export default "__VITE_ASSET__c526b5aa__"